import { render, staticRenderFns } from "./permission_role.vue?vue&type=template&id=c0ad9ffe&scoped=true"
import script from "./permission_role.vue?vue&type=script&lang=js"
export * from "./permission_role.vue?vue&type=script&lang=js"
import style0 from "./permission_role.vue?vue&type=style&index=0&id=c0ad9ffe&prod&lang=scss"
import style1 from "./permission_role.vue?vue&type=style&index=1&id=c0ad9ffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ad9ffe",
  null
  
)

export default component.exports